export const dashboard = {
  extends: 'Page',
  flow: 'x',
  minHeight: '100vh',
  background: 'ink',
  color: 'inkText',
  onRender: (el, s) => {
    const path = window.location.pathname
    const tabMap = {
      '/dashboard': 'appointments',
      '/dashboard/patients': 'patients',
      '/dashboard/calendar': 'calendar',
      '/dashboard/finance': 'finance',
      '/dashboard/settings': 'settings'
    }
    const tab = tabMap[path] || 'appointments'
    if (tab !== s.root.activeTab) {
      s.root.update({ activeTab: tab })
    }
  },

  NavSidebar: {},
  AppointmentModal: {},

  MainContent: {
    flow: 'y',
    flex: '1',
    overflow: 'auto',

    TopBar: {},

    ContentArea: {
      flow: 'y',
      gap: 'B',
      padding: 'B',
      flex: '1',
      '@mobileL': { padding: 'A' },

      // ─── APPOINTMENTS ──────────────────────────────
      AppointmentsView: {
        flow: 'y',
        gap: 'A',
        show: (el, s) => s.root.activeTab === 'appointments',

        StatsRow: {
          flow: 'x',
          gap: 'A',
          flexWrap: 'wrap',
          '@mobileL': { flow: 'y' },
          StatToday: {
            flow: 'y',
            gap: 'Z',
            padding: 'B',
            round: 'A',
            background: 'inkMid',
            border: '1px solid inkBorder',
            flex: '1',
            minWidth: 'E',
            StatLabel: {
              text: "Today's Appts",
              fontSize: 'Z',
              color: 'inkMuted',
              fontWeight: '500'
            },
            StatValue: {
              text: '6',
              fontSize: 'C',
              fontWeight: '700',
              color: 'inkText',
              letterSpacing: '-0.02em'
            }
          },
          StatRevenue: {
            flow: 'y',
            gap: 'Z',
            padding: 'B',
            round: 'A',
            background: 'inkMid',
            border: '1px solid inkBorder',
            flex: '1',
            minWidth: 'E',
            StatLabel: {
              text: '{{ revenueToday | polyglot }}',
              fontSize: 'Z',
              color: 'inkMuted',
              fontWeight: '500'
            },
            StatValue: {
              text: '₾1,380',
              fontSize: 'C',
              fontWeight: '700',
              color: 'inkText',
              letterSpacing: '-0.02em'
            }
          },
          StatNoShows: {
            flow: 'y',
            gap: 'Z',
            padding: 'B',
            round: 'A',
            background: 'inkMid',
            border: '1px solid inkBorder',
            flex: '1',
            minWidth: 'E',
            StatLabel: {
              text: '{{ noshows | polyglot }}',
              fontSize: 'Z',
              color: 'inkMuted',
              fontWeight: '500'
            },
            StatValue: {
              text: '0',
              fontSize: 'C',
              fontWeight: '700',
              color: 'green',
              letterSpacing: '-0.02em'
            }
          },
          StatConfirmed: {
            flow: 'y',
            gap: 'Z',
            padding: 'B',
            round: 'A',
            background: 'inkMid',
            border: '1px solid inkBorder',
            flex: '1',
            minWidth: 'E',
            StatLabel: {
              text: '{{ confirmed | polyglot }}',
              fontSize: 'Z',
              color: 'inkMuted',
              fontWeight: '500'
            },
            StatValue: {
              text: '83%',
              fontSize: 'C',
              fontWeight: '700',
              color: 'inkText',
              letterSpacing: '-0.02em'
            }
          }
        },

        ApptTable: {
          flow: 'y',
          background: 'inkMid',
          round: 'A',
          border: '1px solid inkBorder',
          overflow: 'hidden',

          ApptHeaderRow: {
            display: 'grid',
            gridTemplateColumns: '70px 1fr 1fr 1fr 100px',
            padding: 'Z A',
            borderBottom: '1px solid inkBorder',
            '@mobileL': { display: 'none' },
            ColTime: {
              text: '{{ time | polyglot }}',
              fontSize: 'Y',
              fontWeight: '600',
              color: 'inkMuted',
              textTransform: 'uppercase',
              letterSpacing: 'X'
            },
            ColPatient: {
              text: '{{ patient | polyglot }}',
              fontSize: 'Y',
              fontWeight: '600',
              color: 'inkMuted',
              textTransform: 'uppercase',
              letterSpacing: 'X'
            },
            ColService: {
              text: '{{ service | polyglot }}',
              fontSize: 'Y',
              fontWeight: '600',
              color: 'inkMuted',
              textTransform: 'uppercase',
              letterSpacing: 'X'
            },
            ColDoctor: {
              text: '{{ doctor | polyglot }}',
              fontSize: 'Y',
              fontWeight: '600',
              color: 'inkMuted',
              textTransform: 'uppercase',
              letterSpacing: 'X'
            },
            ColStatus: {
              text: '{{ status2 | polyglot }}',
              fontSize: 'Y',
              fontWeight: '600',
              color: 'inkMuted',
              textTransform: 'uppercase',
              letterSpacing: 'X',
              textAlign: 'right'
            }
          },
          children: (el, s) => s.root.appointments,
          childrenAs: 'state',
          childExtends: 'AppointmentRow'
        }
      },

      // ─── PATIENTS ──────────────────────────────────
      PatientsView: {
        flow: 'y',
        gap: 'A',
        show: (el, s) => s.root.activeTab === 'patients',

        PatientsToolbar: {
          flow: 'x',
          gap: 'A',
          align: 'center space-between',
          '@mobileL': { flow: 'y' },
          PatientSearch: {
            extends: 'Input',
            tag: 'input',
            type: 'text',
            placeholder: 'Search patients...',
            padding: 'Z A',
            round: 'A',
            background: 'inkSurface',
            color: 'inkText',
            border: '1px solid inkBorder',
            fontSize: 'Z',
            flex: '1'
          },
          AddPatientBtn: {
            extends: 'Button',
            text: '{{ addPatient | polyglot }}',
            background: '#0D1117',
            color: '#FFFFFF',
            fontWeight: '600',
            padding: 'Z A',
            round: 'A',
            fontSize: 'Z',
            cursor: 'pointer',
            border: 'none'
          }
        },

        PatientGrid: {
          flow: 'y',
          gap: 'Y',
          children: (el, s) => s.root.patients,
          childrenAs: 'state',
          childExtends: 'PatientCard'
        }
      },

      // ─── CALENDAR ──────────────────────────────────
      CalendarView: {
        flow: 'y',
        gap: 'A',
        show: (el, s) =>
          s.root.activeTab === 'appointments' ||
          s.root.activeTab === 'calendar',

        CalToolbar: {
          flow: 'x',
          align: 'center space-between',
          marginBottom: 'Z',
          CalTitle: {
            tag: 'h3',
            text: '{{ mondayMarch19 | polyglot }}',
            fontSize: 'A',
            fontWeight: '700',
            color: 'inkText'
          },
          DoctorLegend: {
            flow: 'x',
            gap: 'A',
            flexWrap: 'wrap',
            LegDoc1: {
              flow: 'x', gap: 'Y', align: 'center center',
              Dot1: { width: 'Z', height: 'Z', round: 'Z', background: 'teal' },
              Lab1: { text: 'Dr. Lomidze', fontSize: 'Y', color: 'inkMuted' }
            },
            LegDoc2: {
              flow: 'x', gap: 'Y', align: 'center center',
              Dot2: { width: 'Z', height: 'Z', round: 'Z', background: 'amber' },
              Lab2: { text: 'Dr. Beridze', fontSize: 'Y', color: 'inkMuted' }
            },
            LegDoc3: {
              flow: 'x', gap: 'Y', align: 'center center',
              Dot3: { width: 'Z', height: 'Z', round: 'Z', background: 'purple' },
              Lab3: { text: 'Dr. Kvaratskhelia', fontSize: 'Y', color: 'inkMuted' }
            },
            LegDoc4: {
              flow: 'x', gap: 'Y', align: 'center center',
              Dot4: { width: 'Z', height: 'Z', round: 'Z', background: 'green' },
              Lab4: { text: 'Hyg. Nino', fontSize: 'Y', color: 'inkMuted' }
            }
          }
        },

        CalendarGrid: {
          flow: 'y',
          background: 'inkMid',
          round: 'A',
          border: '1px solid inkBorder',
          overflow: 'auto',
          maxHeight: 'J',

          Row0800: {
            flow: 'x', borderBottom: '1px solid inkBorder', minHeight: 'C',
            TimeLabel: { width: 'D', padding: 'Y Z', fontSize: 'Y', color: 'inkMuted', textAlign: 'right', text: '08:00', flexShrink: '0' },
            SlotArea: {
              flex: '1', flow: 'x', gap: 'Y', borderLeft: '1px solid inkBorder', padding: 'Y Z',
              EvtA: { flow: 'y', gap: 'X', flex: '1', padding: 'Y Z', round: 'Y', borderLeft: '3px solid teal', paddingLeft: 'Z', background: 'teal.08', cursor: 'pointer', ':hover': { background: 'teal.15' }, onClick: (e, el, s) => s.root.update({ selectedAppointment: { patient: 'R. Kharazishvili', time: '08:00', service: 'Crown Consult', doctor: 'Dr. Lomidze', status: 'Confirmed' }, showAppointmentModal: true }), Name: { text: 'R. Kharazishvili — Crown Consult', fontSize: 'Y', color: 'inkText' }, Meta: { text: 'Dr. Lomidze · Cab 1', fontSize: 'X', color: 'inkMuted' } },
              EvtB: { flow: 'y', gap: 'X', flex: '1', padding: 'Y Z', round: 'Y', borderLeft: '3px solid amber', paddingLeft: 'Z', background: 'amber.08', cursor: 'pointer', ':hover': { background: 'amber.15' }, onClick: (e, el, s) => s.root.update({ selectedAppointment: { patient: 'K. Gabrichidze', time: '08:00', service: 'New Patient Exam', doctor: 'Dr. Beridze', status: 'Confirmed' }, showAppointmentModal: true }), Name: { text: 'K. Gabrichidze — New Patient Exam', fontSize: 'Y', color: 'inkText' }, Meta: { text: 'Dr. Beridze · Cab 2', fontSize: 'X', color: 'inkMuted' } }
            }
          },
          Row0830: {
            flow: 'x', borderBottom: '1px solid inkBorder', minHeight: 'C',
            TimeLabel: { width: 'D', padding: 'Y Z', fontSize: 'Y', color: 'inkMuted', textAlign: 'right', text: '08:30', flexShrink: '0' },
            SlotArea: {
              flex: '1', flow: 'x', gap: 'Y', borderLeft: '1px solid inkBorder', padding: 'Y Z',
              EvtA: { flow: 'y', gap: 'X', flex: '1', padding: 'Y Z', round: 'Y', borderLeft: '3px solid purple', paddingLeft: 'Z', background: 'purple.08', cursor: 'pointer', ':hover': { background: 'purple.15' }, onClick: (e, el, s) => s.root.update({ selectedAppointment: { patient: 'T. Kapanadze', time: '08:30', service: 'Consultation', doctor: 'Dr. Kvaratskhelia', status: 'Confirmed' }, showAppointmentModal: true }), Name: { text: 'T. Kapanadze — Consultation', fontSize: 'Y', color: 'inkText' }, Meta: { text: 'Dr. Kvaratskhelia · Cab 1', fontSize: 'X', color: 'inkMuted' } },
              EvtB: { flow: 'y', gap: 'X', flex: '1', padding: 'Y Z', round: 'Y', borderLeft: '3px solid amber', paddingLeft: 'Z', background: 'amber.08', cursor: 'pointer', ':hover': { background: 'amber.15' }, onClick: (e, el, s) => s.root.update({ selectedAppointment: { patient: 'K. Gabrichidze', time: '08:30', service: 'New Patient Exam cont.', doctor: 'Dr. Beridze', status: 'Confirmed' }, showAppointmentModal: true }), Name: { text: 'K. Gabrichidze — Exam cont.', fontSize: 'Y', color: 'inkText' }, Meta: { text: 'Dr. Beridze · Cab 2', fontSize: 'X', color: 'inkMuted' } }
            }
          },

          Row0900: {
            flow: 'x', borderBottom: '1px solid inkBorder', minHeight: 'C',
            TimeLabel: { width: 'D', padding: 'Y Z', fontSize: 'Y', color: 'inkMuted', textAlign: 'right', text: '09:00', fontWeight: '600', flexShrink: '0' },
            SlotArea: {
              flex: '1', flow: 'x', gap: 'Y', borderLeft: '1px solid inkBorder', padding: 'Y Z',
              EvtA: { flow: 'y', gap: 'X', flex: '1', padding: 'Y Z', round: 'Y', borderLeft: '3px solid teal', paddingLeft: 'Z', background: 'teal.08', cursor: 'pointer', ':hover': { background: 'teal.15' }, onClick: (e, el, s) => s.root.update({ selectedAppointment: { patient: 'Giorgi Beridze', time: '09:00', service: 'Checkup', doctor: 'Dr. Lomidze', status: 'Confirmed' }, showAppointmentModal: true }), Name: { text: 'G. Beridze — Checkup', fontSize: 'Y', color: 'inkText' }, Meta: { text: 'Dr. Lomidze · Cab 1', fontSize: 'X', color: 'inkMuted' } },
              EvtB: { flow: 'y', gap: 'X', flex: '1', padding: 'Y Z', round: 'Y', borderLeft: '3px solid amber', paddingLeft: 'Z', background: 'amber.08', cursor: 'pointer', ':hover': { background: 'amber.15' }, onClick: (e, el, s) => s.root.update({ selectedAppointment: { patient: 'D. Gelashvili', time: '09:00', service: 'SRP Quad', doctor: 'Dr. Beridze', status: 'Confirmed' }, showAppointmentModal: true }), Name: { text: 'D. Gelashvili — SRP Quad', fontSize: 'Y', color: 'inkText' }, Meta: { text: 'Dr. Beridze · Cab 2', fontSize: 'X', color: 'inkMuted' } },
              EvtC: { flow: 'y', gap: 'X', flex: '1', padding: 'Y Z', round: 'Y', borderLeft: '3px solid green', paddingLeft: 'Z', background: 'green.08', cursor: 'pointer', ':hover': { background: 'green.15' }, onClick: (e, el, s) => s.root.update({ selectedAppointment: { patient: 'I. Diasamidze', time: '09:00', service: 'Prophy Clean', doctor: 'Hyg. Nino', status: 'Confirmed' }, showAppointmentModal: true }), Name: { text: 'I. Diasamidze — Prophy Clean', fontSize: 'Y', color: 'inkText' }, Meta: { text: 'Hyg. Nino · Cab 3', fontSize: 'X', color: 'inkMuted' } }
            }
          },
          Row0930: {
            flow: 'x', borderBottom: '1px solid inkBorder', minHeight: 'C',
            TimeLabel: { width: 'D', padding: 'Y Z', fontSize: 'Y', color: 'inkMuted', textAlign: 'right', text: '09:30', flexShrink: '0' },
            SlotArea: {
              flex: '1', flow: 'x', gap: 'Y', borderLeft: '1px solid inkBorder', padding: 'Y Z',
              EvtA: { flow: 'y', gap: 'X', flex: '1', padding: 'Y Z', round: 'Y', borderLeft: '3px solid purple', paddingLeft: 'Z', background: 'purple.08', cursor: 'pointer', ':hover': { background: 'purple.15' }, Name: { text: 'T. Kapanadze — Crown Prep', fontSize: 'Y', color: 'inkText' }, Meta: { text: 'Dr. Kvaratskhelia · Cab 1', fontSize: 'X', color: 'inkMuted' } },
              EvtB: { flow: 'y', gap: 'X', flex: '1', padding: 'Y Z', round: 'Y', borderLeft: '3px solid amber', paddingLeft: 'Z', background: 'amber.08', cursor: 'pointer', ':hover': { background: 'amber.15' }, Name: { text: 'D. Gelashvili — SRP cont.', fontSize: 'Y', color: 'inkText' }, Meta: { text: 'Dr. Beridze · Cab 2', fontSize: 'X', color: 'inkMuted' } }
            }
          },

          Row1000: {
            flow: 'x', borderBottom: '1px solid inkBorder', minHeight: 'C',
            TimeLabel: { width: 'D', padding: 'Y Z', fontSize: 'Y', color: 'inkMuted', textAlign: 'right', text: '10:00', fontWeight: '600', flexShrink: '0' },
            SlotArea: {
              flex: '1', flow: 'x', gap: 'Y', borderLeft: '1px solid inkBorder', padding: 'Y Z',
              EvtA: { flow: 'y', gap: 'X', flex: '1', padding: 'Y Z', round: 'Y', borderLeft: '3px solid teal', paddingLeft: 'Z', background: 'teal.08', cursor: 'pointer', ':hover': { background: 'teal.15' }, Name: { text: 'M. Tsiklauri — Exam + X-Ray', fontSize: 'Y', color: 'inkText' }, Meta: { text: 'Dr. Lomidze · Cab 1', fontSize: 'X', color: 'inkMuted' } },
              EvtB: { flow: 'y', gap: 'X', flex: '1', padding: 'Y Z', round: 'Y', borderLeft: '3px solid green', paddingLeft: 'Z', background: 'green.08', cursor: 'pointer', ':hover': { background: 'green.15' }, Name: { text: 'T. Lomidze — Perio Maint.', fontSize: 'Y', color: 'inkText' }, Meta: { text: 'Hyg. Nino · Cab 3', fontSize: 'X', color: 'inkMuted' } }
            }
          },
          Row1030: {
            flow: 'x', borderBottom: '1px solid inkBorder', minHeight: 'C',
            TimeLabel: { width: 'D', padding: 'Y Z', fontSize: 'Y', color: 'inkMuted', textAlign: 'right', text: '10:30', flexShrink: '0' },
            SlotArea: {
              flex: '1', flow: 'x', gap: 'Y', borderLeft: '1px solid inkBorder', padding: 'Y Z',
              EvtA: { flow: 'y', gap: 'X', flex: '1', padding: 'Y Z', round: 'Y', borderLeft: '3px solid purple', paddingLeft: 'Z', background: 'purple.08', cursor: 'pointer', ':hover': { background: 'purple.15' }, onClick: (e, el, s) => s.root.update({ selectedAppointment: { patient: 'Nino Kapanadze', time: '10:30', service: 'Whitening', doctor: 'Dr. Kvaratskhelia', status: 'Pending' }, showAppointmentModal: true }), Name: { text: 'N. Kapanadze — Whitening', fontSize: 'Y', color: 'inkText' }, Meta: { text: 'Dr. Kvaratskhelia · Cab 1', fontSize: 'X', color: 'inkMuted' } },
              EvtB: { flow: 'y', gap: 'X', flex: '1', padding: 'Y Z', round: 'Y', borderLeft: '3px solid amber', paddingLeft: 'Z', background: 'amber.08', cursor: 'pointer', ':hover': { background: 'amber.15' }, Name: { text: 'Z. Dolidze — Implant Consult', fontSize: 'Y', color: 'inkText' }, Meta: { text: 'Dr. Beridze · Cab 2', fontSize: 'X', color: 'inkMuted' } },
              EvtC: { flow: 'y', gap: 'X', flex: '1', padding: 'Y Z', round: 'Y', borderLeft: '3px solid green', paddingLeft: 'Z', background: 'green.08', cursor: 'pointer', ':hover': { background: 'green.15' }, Name: { text: 'N. Gogiberidze — Fluoride Tx', fontSize: 'Y', color: 'inkText' }, Meta: { text: 'Hyg. Nino · Cab 3', fontSize: 'X', color: 'inkMuted' } }
            }
          },

          Row1100: {
            flow: 'x', borderBottom: '1px solid inkBorder', minHeight: 'C',
            TimeLabel: { width: 'D', padding: 'Y Z', fontSize: 'Y', color: 'inkMuted', textAlign: 'right', text: '11:00', fontWeight: '600', flexShrink: '0' },
            SlotArea: {
              flex: '1', flow: 'x', gap: 'Y', borderLeft: '1px solid inkBorder', padding: 'Y Z',
              EvtA: { flow: 'y', gap: 'X', flex: '1', padding: 'Y Z', round: 'Y', borderLeft: '3px solid teal', paddingLeft: 'Z', background: 'teal.08', cursor: 'pointer', ':hover': { background: 'teal.15' }, onClick: (e, el, s) => s.root.update({ selectedAppointment: { patient: 'Davit Gelashvili', time: '11:00', service: 'Implant Phase 2', doctor: 'Dr. Lomidze', status: 'Confirmed' }, showAppointmentModal: true }), Name: { text: 'D. Gelashvili — Implant Ph.2', fontSize: 'Y', color: 'inkText' }, Meta: { text: 'Dr. Lomidze · Cab 2', fontSize: 'X', color: 'inkMuted' } },
              EvtB: { flow: 'y', gap: 'X', flex: '1', padding: 'Y Z', round: 'Y', borderLeft: '3px solid purple', paddingLeft: 'Z', background: 'purple.08', cursor: 'pointer', ':hover': { background: 'purple.15' }, Name: { text: 'S. Meladze — Composite Fill', fontSize: 'Y', color: 'inkText' }, Meta: { text: 'Dr. Kvaratskhelia · Cab 1', fontSize: 'X', color: 'inkMuted' } },
              EvtC: { flow: 'y', gap: 'X', flex: '1', padding: 'Y Z', round: 'Y', borderLeft: '3px solid green', paddingLeft: 'Z', background: 'green.08', cursor: 'pointer', ':hover': { background: 'green.15' }, Name: { text: 'L. Mchedlishvili — Sealants', fontSize: 'Y', color: 'inkText' }, Meta: { text: 'Hyg. Nino · Cab 3', fontSize: 'X', color: 'inkMuted' } }
            }
          },
          Row1130: {
            flow: 'x', borderBottom: '1px solid inkBorder', minHeight: 'C',
            TimeLabel: { width: 'D', padding: 'Y Z', fontSize: 'Y', color: 'inkMuted', textAlign: 'right', text: '11:30', flexShrink: '0' },
            SlotArea: {
              flex: '1', flow: 'x', gap: 'Y', borderLeft: '1px solid inkBorder', padding: 'Y Z',
              EvtA: { flow: 'y', gap: 'X', flex: '1', padding: 'Y Z', round: 'Y', borderLeft: '3px solid teal', paddingLeft: 'Z', background: 'teal.08', cursor: 'pointer', ':hover': { background: 'teal.15' }, Name: { text: 'R. Kharazishvili — Bridge Prep', fontSize: 'Y', color: 'inkText' }, Meta: { text: 'Dr. Lomidze · Cab 1', fontSize: 'X', color: 'inkMuted' } },
              EvtB: { flow: 'y', gap: 'X', flex: '1', padding: 'Y Z', round: 'Y', borderLeft: '3px solid amber', paddingLeft: 'Z', background: 'amber.08', cursor: 'pointer', ':hover': { background: 'amber.15' }, Name: { text: 'E. Tsereteli — Perio Check', fontSize: 'Y', color: 'inkText' }, Meta: { text: 'Dr. Beridze · Cab 2', fontSize: 'X', color: 'inkMuted' } }
            }
          },

          Row1200: {
            flow: 'x', borderBottom: '1px solid inkBorder', minHeight: 'C',
            TimeLabel: { width: 'D', padding: 'Y Z', fontSize: 'Y', color: 'inkMuted', textAlign: 'right', text: '12:00', fontWeight: '600', flexShrink: '0' },
            SlotArea: {
              flex: '1', borderLeft: '1px solid inkBorder', padding: 'Y Z',
              LunchLabel: { text: '{{ lunchBreak | polyglot }}', fontSize: 'Y', color: 'inkMuted', fontStyle: 'italic' }
            }
          },
          Row1230: {
            flow: 'x', borderBottom: '1px solid inkBorder', minHeight: 'C',
            TimeLabel: { width: 'D', padding: 'Y Z', fontSize: 'Y', color: 'inkMuted', textAlign: 'right', text: '12:30', flexShrink: '0' },
            SlotArea: {
              flex: '1', flow: 'x', gap: 'Y', borderLeft: '1px solid inkBorder', padding: 'Y Z',
              EvtA: { flow: 'y', gap: 'X', flex: '1', padding: 'Y Z', round: 'Y', borderLeft: '3px solid purple', paddingLeft: 'Z', background: 'purple.08', cursor: 'pointer', ':hover': { background: 'purple.15' }, Name: { text: 'A. Javakhishvili — Post-Op Review', fontSize: 'Y', color: 'inkText' }, Meta: { text: 'Dr. Kvaratskhelia · Cab 4', fontSize: 'X', color: 'inkMuted' } }
            }
          },

          Row1300: {
            flow: 'x', borderBottom: '1px solid inkBorder', minHeight: 'C',
            TimeLabel: { width: 'D', padding: 'Y Z', fontSize: 'Y', color: 'inkMuted', textAlign: 'right', text: '13:00', fontWeight: '600', flexShrink: '0' },
            SlotArea: {
              flex: '1', flow: 'x', gap: 'Y', borderLeft: '1px solid inkBorder', padding: 'Y Z',
              EvtA: { flow: 'y', gap: 'X', flex: '1', padding: 'Y Z', round: 'Y', borderLeft: '3px solid purple', paddingLeft: 'Z', background: 'purple.08', cursor: 'pointer', ':hover': { background: 'purple.15' }, Name: { text: 'V. Papunashvili — Post-Op Check', fontSize: 'Y', color: 'inkText' }, Meta: { text: 'Dr. Kvaratskhelia · Cab 4', fontSize: 'X', color: 'inkMuted' } },
              EvtB: { flow: 'y', gap: 'X', flex: '1', padding: 'Y Z', round: 'Y', borderLeft: '3px solid amber', paddingLeft: 'Z', background: 'amber.08', cursor: 'pointer', ':hover': { background: 'amber.15' }, Name: { text: 'A. Javakhishvili — Consultation', fontSize: 'Y', color: 'inkText' }, Meta: { text: 'Dr. Beridze · Cab 2', fontSize: 'X', color: 'inkMuted' } }
            }
          },
          Row1330: {
            flow: 'x', borderBottom: '1px solid inkBorder', minHeight: 'C',
            TimeLabel: { width: 'D', padding: 'Y Z', fontSize: 'Y', color: 'inkMuted', textAlign: 'right', text: '13:30', flexShrink: '0' },
            SlotArea: {
              flex: '1', flow: 'x', gap: 'Y', borderLeft: '1px solid inkBorder', padding: 'Y Z',
              EvtA: { flow: 'y', gap: 'X', flex: '1', padding: 'Y Z', round: 'Y', borderLeft: '3px solid teal', paddingLeft: 'Z', background: 'teal.08', cursor: 'pointer', ':hover': { background: 'teal.15' }, Name: { text: 'B. Shengelia — Exam', fontSize: 'Y', color: 'inkText' }, Meta: { text: 'Dr. Lomidze · Cab 1', fontSize: 'X', color: 'inkMuted' } },
              EvtB: { flow: 'y', gap: 'X', flex: '1', padding: 'Y Z', round: 'Y', borderLeft: '3px solid amber', paddingLeft: 'Z', background: 'amber.08', cursor: 'pointer', ':hover': { background: 'amber.15' }, Name: { text: 'G. Beridze — Whitening', fontSize: 'Y', color: 'inkText' }, Meta: { text: 'Dr. Beridze · Cab 4', fontSize: 'X', color: 'inkMuted' } }
            }
          },

          Row1400: {
            flow: 'x', borderBottom: '1px solid inkBorder', minHeight: 'C',
            TimeLabel: { width: 'D', padding: 'Y Z', fontSize: 'Y', color: 'inkMuted', textAlign: 'right', text: '14:00', fontWeight: '600', flexShrink: '0' },
            SlotArea: {
              flex: '1', flow: 'x', gap: 'Y', borderLeft: '1px solid inkBorder', padding: 'Y Z',
              EvtA: { flow: 'y', gap: 'X', flex: '1', padding: 'Y Z', round: 'Y', borderLeft: '3px solid teal', paddingLeft: 'Z', background: 'teal.08', cursor: 'pointer', ':hover': { background: 'teal.15' }, Name: { text: 'K. Gabrichidze — Root Canal', fontSize: 'Y', color: 'inkText' }, Meta: { text: 'Dr. Lomidze · Cab 1', fontSize: 'X', color: 'inkMuted' } },
              EvtB: { flow: 'y', gap: 'X', flex: '1', padding: 'Y Z', round: 'Y', borderLeft: '3px solid amber', paddingLeft: 'Z', background: 'amber.08', cursor: 'pointer', ':hover': { background: 'amber.15' }, onClick: (e, el, s) => s.root.update({ selectedAppointment: { patient: 'Mariam Tsiklauri', time: '14:00', service: 'Orthodontics', doctor: 'Dr. Beridze', status: 'Confirmed' }, showAppointmentModal: true }), Name: { text: 'M. Tsiklauri — Orthodontics', fontSize: 'Y', color: 'inkText' }, Meta: { text: 'Dr. Beridze · Cab 2', fontSize: 'X', color: 'inkMuted' } },
              EvtC: { flow: 'y', gap: 'X', flex: '1', padding: 'Y Z', round: 'Y', borderLeft: '3px solid purple', paddingLeft: 'Z', background: 'purple.08', cursor: 'pointer', ':hover': { background: 'purple.15' }, Name: { text: 'V. Papunashvili — Extraction', fontSize: 'Y', color: 'inkText' }, Meta: { text: 'Dr. Kvaratskhelia · Cab 4', fontSize: 'X', color: 'inkMuted' } }
            }
          },
          Row1430: {
            flow: 'x', borderBottom: '1px solid inkBorder', minHeight: 'C',
            TimeLabel: { width: 'D', padding: 'Y Z', fontSize: 'Y', color: 'inkMuted', textAlign: 'right', text: '14:30', flexShrink: '0' },
            SlotArea: {
              flex: '1', flow: 'x', gap: 'Y', borderLeft: '1px solid inkBorder', padding: 'Y Z',
              EvtA: { flow: 'y', gap: 'X', flex: '1', padding: 'Y Z', round: 'Y', borderLeft: '3px solid teal', paddingLeft: 'Z', background: 'teal.08', cursor: 'pointer', ':hover': { background: 'teal.15' }, Name: { text: 'K. Gabrichidze — Root Canal cont.', fontSize: 'Y', color: 'inkText' }, Meta: { text: 'Dr. Lomidze · Cab 1', fontSize: 'X', color: 'inkMuted' } },
              EvtB: { flow: 'y', gap: 'X', flex: '1', padding: 'Y Z', round: 'Y', borderLeft: '3px solid amber', paddingLeft: 'Z', background: 'amber.08', cursor: 'pointer', ':hover': { background: 'amber.15' }, Name: { text: 'Z. Dolidze — Implant Place', fontSize: 'Y', color: 'inkText' }, Meta: { text: 'Dr. Beridze · Cab 2', fontSize: 'X', color: 'inkMuted' } }
            }
          },

          Row1500: {
            flow: 'x', borderBottom: '1px solid inkBorder', minHeight: 'C',
            TimeLabel: { width: 'D', padding: 'Y Z', fontSize: 'Y', color: 'inkMuted', textAlign: 'right', text: '15:00', fontWeight: '600', flexShrink: '0' },
            SlotArea: {
              flex: '1', flow: 'x', gap: 'Y', borderLeft: '1px solid inkBorder', padding: 'Y Z',
              EvtA: { flow: 'y', gap: 'X', flex: '1', padding: 'Y Z', round: 'Y', borderLeft: '3px solid purple', paddingLeft: 'Z', background: 'purple.08', cursor: 'pointer', ':hover': { background: 'purple.15' }, Name: { text: 'T. Kapanadze — Crown Seat', fontSize: 'Y', color: 'inkText' }, Meta: { text: 'Dr. Kvaratskhelia · Cab 1', fontSize: 'X', color: 'inkMuted' } },
              EvtB: { flow: 'y', gap: 'X', flex: '1', padding: 'Y Z', round: 'Y', borderLeft: '3px solid amber', paddingLeft: 'Z', background: 'amber.08', cursor: 'pointer', ':hover': { background: 'amber.15' }, Name: { text: 'L. Mchedlishvili — Ortho Check', fontSize: 'Y', color: 'inkText' }, Meta: { text: 'Dr. Beridze · Cab 2', fontSize: 'X', color: 'inkMuted' } }
            }
          },
          Row1530: {
            flow: 'x', borderBottom: '1px solid inkBorder', minHeight: 'C',
            TimeLabel: { width: 'D', padding: 'Y Z', fontSize: 'Y', color: 'inkMuted', textAlign: 'right', text: '15:30', flexShrink: '0' },
            SlotArea: {
              flex: '1', flow: 'x', gap: 'Y', borderLeft: '1px solid inkBorder', padding: 'Y Z',
              EvtA: { flow: 'y', gap: 'X', flex: '1', padding: 'Y Z', round: 'Y', borderLeft: '3px solid teal', paddingLeft: 'Z', background: 'teal.08', cursor: 'pointer', ':hover': { background: 'teal.15' }, onClick: (e, el, s) => s.root.update({ selectedAppointment: { patient: 'Ana Javakhishvili', time: '15:30', service: 'Root Canal', doctor: 'Dr. Lomidze', status: 'Pending' }, showAppointmentModal: true }), Name: { text: 'A. Javakhishvili — Root Canal', fontSize: 'Y', color: 'inkText' }, Meta: { text: 'Dr. Lomidze · Cab 1', fontSize: 'X', color: 'inkMuted' } },
              EvtB: { flow: 'y', gap: 'X', flex: '1', padding: 'Y Z', round: 'Y', borderLeft: '3px solid green', paddingLeft: 'Z', background: 'green.08', cursor: 'pointer', ':hover': { background: 'green.15' }, Name: { text: 'B. Shengelia — Prophy Clean', fontSize: 'Y', color: 'inkText' }, Meta: { text: 'Hyg. Nino · Cab 3', fontSize: 'X', color: 'inkMuted' } },
              EvtC: { flow: 'y', gap: 'X', flex: '1', padding: 'Y Z', round: 'Y', borderLeft: '3px solid purple', paddingLeft: 'Z', background: 'purple.08', cursor: 'pointer', ':hover': { background: 'purple.15' }, Name: { text: 'N. Kapanadze — Composite', fontSize: 'Y', color: 'inkText' }, Meta: { text: 'Dr. Kvaratskhelia · Cab 4', fontSize: 'X', color: 'inkMuted' } }
            }
          },

          Row1600: {
            flow: 'x', borderBottom: '1px solid inkBorder', minHeight: 'C',
            TimeLabel: { width: 'D', padding: 'Y Z', fontSize: 'Y', color: 'inkMuted', textAlign: 'right', text: '16:00', fontWeight: '600', flexShrink: '0' },
            SlotArea: {
              flex: '1', flow: 'x', gap: 'Y', borderLeft: '1px solid inkBorder', padding: 'Y Z',
              EvtA: { flow: 'y', gap: 'X', flex: '1', padding: 'Y Z', round: 'Y', borderLeft: '3px solid teal', paddingLeft: 'Z', background: 'teal.08', cursor: 'pointer', ':hover': { background: 'teal.15' }, Name: { text: 'D. Gelashvili — Follow-Up', fontSize: 'Y', color: 'inkText' }, Meta: { text: 'Dr. Lomidze · Cab 1', fontSize: 'X', color: 'inkMuted' } },
              EvtB: { flow: 'y', gap: 'X', flex: '1', padding: 'Y Z', round: 'Y', borderLeft: '3px solid green', paddingLeft: 'Z', background: 'green.08', cursor: 'pointer', ':hover': { background: 'green.15' }, Name: { text: 'I. Diasamidze — Perio Review', fontSize: 'Y', color: 'inkText' }, Meta: { text: 'Hyg. Nino · Cab 3', fontSize: 'X', color: 'inkMuted' } }
            }
          },
          Row1630: {
            flow: 'x', borderBottom: '1px solid inkBorder', minHeight: 'C',
            TimeLabel: { width: 'D', padding: 'Y Z', fontSize: 'Y', color: 'inkMuted', textAlign: 'right', text: '16:30', flexShrink: '0' },
            SlotArea: {
              flex: '1', flow: 'x', gap: 'Y', borderLeft: '1px solid inkBorder', padding: 'Y Z',
              EvtA: { flow: 'y', gap: 'X', flex: '1', padding: 'Y Z', round: 'Y', borderLeft: '3px solid amber', paddingLeft: 'Z', background: 'amber.08', cursor: 'pointer', ':hover': { background: 'amber.15' }, Name: { text: 'E. Tsereteli — Exam Consult', fontSize: 'Y', color: 'inkText' }, Meta: { text: 'Dr. Beridze · Cab 2', fontSize: 'X', color: 'inkMuted' } }
            }
          },

          Row1700: {
            flow: 'x', borderBottom: '1px solid inkBorder', minHeight: 'C',
            TimeLabel: { width: 'D', padding: 'Y Z', fontSize: 'Y', color: 'inkMuted', textAlign: 'right', text: '17:00', fontWeight: '600', flexShrink: '0' },
            SlotArea: {
              flex: '1', flow: 'x', gap: 'Y', borderLeft: '1px solid inkBorder', padding: 'Y Z',
              EvtA: { flow: 'y', gap: 'X', flex: '1', padding: 'Y Z', round: 'Y', borderLeft: '3px solid purple', paddingLeft: 'Z', background: 'purple.08', cursor: 'pointer', ':hover': { background: 'purple.15' }, onClick: (e, el, s) => s.root.update({ selectedAppointment: { patient: 'Luka Mchedlishvili', time: '17:00', service: 'Extraction', doctor: 'Dr. Kvaratskhelia', status: 'Cancelled' }, showAppointmentModal: true }), Name: { text: 'L. Mchedlishvili — Extraction', fontSize: 'Y', color: 'inkText' }, Meta: { text: 'Dr. Kvaratskhelia · Cab 4', fontSize: 'X', color: 'inkMuted' } },
              EvtB: { flow: 'y', gap: 'X', flex: '1', padding: 'Y Z', round: 'Y', borderLeft: '3px solid teal', paddingLeft: 'Z', background: 'teal.08', cursor: 'pointer', ':hover': { background: 'teal.15' }, Name: { text: 'T. Lomidze — Scaling', fontSize: 'Y', color: 'inkText' }, Meta: { text: 'Dr. Lomidze · Cab 1', fontSize: 'X', color: 'inkMuted' } }
            }
          },
          Row1730: {
            flow: 'x', borderBottom: '1px solid inkBorder', minHeight: 'C',
            TimeLabel: { width: 'D', padding: 'Y Z', fontSize: 'Y', color: 'inkMuted', textAlign: 'right', text: '17:30', flexShrink: '0' },
            SlotArea: {
              flex: '1', flow: 'x', gap: 'Y', borderLeft: '1px solid inkBorder', padding: 'Y Z',
              EvtA: { flow: 'y', gap: 'X', flex: '1', padding: 'Y Z', round: 'Y', borderLeft: '3px solid amber', paddingLeft: 'Z', background: 'amber.08', cursor: 'pointer', ':hover': { background: 'amber.15' }, Name: { text: 'M. Tsiklauri — Retainer Check', fontSize: 'Y', color: 'inkText' }, Meta: { text: 'Dr. Beridze · Cab 2', fontSize: 'X', color: 'inkMuted' } }
            }
          },

          Row1800: {
            flow: 'x', borderBottom: '1px solid inkBorder', minHeight: 'C',
            TimeLabel: { width: 'D', padding: 'Y Z', fontSize: 'Y', color: 'inkMuted', textAlign: 'right', text: '18:00', fontWeight: '600', flexShrink: '0' },
            SlotArea: {
              flex: '1', flow: 'x', gap: 'Y', borderLeft: '1px solid inkBorder', padding: 'Y Z',
              EvtA: { flow: 'y', gap: 'X', flex: '1', padding: 'Y Z', round: 'Y', borderLeft: '3px solid amber', paddingLeft: 'Z', background: 'amber.08', cursor: 'pointer', ':hover': { background: 'amber.15' }, onClick: (e, el, s) => s.root.update({ selectedAppointment: { patient: 'Tamara Lomidze', time: '18:00', service: 'Checkup', doctor: 'Dr. Beridze', status: 'Confirmed' }, showAppointmentModal: true }), Name: { text: 'T. Lomidze — Checkup', fontSize: 'Y', color: 'inkText' }, Meta: { text: 'Dr. Beridze · Cab 2', fontSize: 'X', color: 'inkMuted' } },
              EvtB: { flow: 'y', gap: 'X', flex: '1', padding: 'Y Z', round: 'Y', borderLeft: '3px solid purple', paddingLeft: 'Z', background: 'purple.08', cursor: 'pointer', ':hover': { background: 'purple.15' }, Name: { text: 'N. Gogiberidze — Emergency', fontSize: 'Y', color: 'inkText' }, Meta: { text: 'Dr. Kvaratskhelia · Cab 4', fontSize: 'X', color: 'inkMuted' } }
            }
          },
          Row1830: {
            flow: 'x', borderBottom: '1px solid inkBorder', minHeight: 'C',
            TimeLabel: { width: 'D', padding: 'Y Z', fontSize: 'Y', color: 'inkMuted', textAlign: 'right', text: '18:30', flexShrink: '0' },
            SlotArea: { flex: '1', borderLeft: '1px solid inkBorder', padding: 'Y Z' }
          },
          Row1900: {
            flow: 'x', minHeight: 'C',
            TimeLabel: { width: 'D', padding: 'Y Z', fontSize: 'Y', color: 'inkMuted', textAlign: 'right', text: '19:00', fontWeight: '600', flexShrink: '0' },
            SlotArea: { flex: '1', borderLeft: '1px solid inkBorder', padding: 'Y Z' }
          }
        }
      },

      // ─── SETTINGS ─────────────────────────────────
      SettingsView: {
        flow: 'y',
        gap: 'A',
        show: (el, s) => s.root.activeTab === 'settings',

        SettingsForm: {
          flow: 'y',
          gap: 'A',
          padding: 'B',
          round: 'A',
          background: 'inkMid',
          border: '1px solid inkBorder',
          FieldClinicName: {
            flow: 'y',
            gap: 'Y',
            FieldLabel: {
              tag: 'label',
              text: '{{ clinicName | polyglot }}',
              fontSize: 'Z',
              fontWeight: '500',
              color: 'inkMuted'
            },
            FieldInput: {
              extends: 'Input',
              tag: 'input',
              type: 'text',
              placeholder: 'Your Clinic Name',
              value: 'Denta Plus',
              padding: 'Z A',
              round: 'A',
              background: 'inkSurface',
              color: 'inkText',
              border: '1px solid inkBorder',
              fontSize: 'Z',
              width: '100%'
            }
          },
          FieldPhone: {
            flow: 'y',
            gap: 'Y',
            FieldLabel: {
              tag: 'label',
              text: '{{ phone | polyglot }}',
              fontSize: 'Z',
              fontWeight: '500',
              color: 'inkMuted'
            },
            FieldInput: {
              extends: 'Input',
              tag: 'input',
              type: 'tel',
              placeholder: '+995 XXX XXX XXX',
              value: '+995 555 123 456',
              padding: 'Z A',
              round: 'A',
              background: 'inkSurface',
              color: 'inkText',
              border: '1px solid inkBorder',
              fontSize: 'Z',
              width: '100%'
            }
          },
          FieldAddress: {
            flow: 'y',
            gap: 'Y',
            FieldLabel: {
              tag: 'label',
              text: '{{ address | polyglot }}',
              fontSize: 'Z',
              fontWeight: '500',
              color: 'inkMuted'
            },
            FieldInput: {
              extends: 'Input',
              tag: 'input',
              type: 'text',
              placeholder: 'Street, City',
              value: 'Rustaveli Ave 42, Tbilisi',
              padding: 'Z A',
              round: 'A',
              background: 'inkSurface',
              color: 'inkText',
              border: '1px solid inkBorder',
              fontSize: 'Z',
              width: '100%'
            }
          },
          InsuranceSection: {
            flow: 'y',
            gap: 'Z',
            marginTop: 'A',
            InsuranceLabel: {
              text: '{{ acceptedInsurance | polyglot }}',
              fontSize: 'Z',
              fontWeight: '500',
              color: 'inkMuted',
              marginBottom: 'Y'
            },
            InsCheckAldagi: {
              flow: 'x',
              gap: 'Y',
              align: 'center flex-start',
              cursor: 'pointer',
              CheckBox: {
                tag: 'input',
                attr: { type: 'checkbox', checked: true },
                width: 'Z',
                height: 'Z'
              },
              CheckLabel: { text: 'Aldagi', fontSize: 'Z', color: 'inkText' }
            },
            InsCheckGpi: {
              flow: 'x',
              gap: 'Y',
              align: 'center flex-start',
              cursor: 'pointer',
              CheckBox: {
                tag: 'input',
                attr: { type: 'checkbox', checked: true },
                width: 'Z',
                height: 'Z'
              },
              CheckLabel: { text: 'GPI', fontSize: 'Z', color: 'inkText' }
            },
            InsCheckImedi: {
              flow: 'x',
              gap: 'Y',
              align: 'center flex-start',
              cursor: 'pointer',
              CheckBox: {
                tag: 'input',
                attr: { type: 'checkbox' },
                width: 'Z',
                height: 'Z'
              },
              CheckLabel: { text: 'Imedi L', fontSize: 'Z', color: 'inkText' }
            },
            InsCheckUnison: {
              flow: 'x',
              gap: 'Y',
              align: 'center flex-start',
              cursor: 'pointer',
              CheckBox: {
                tag: 'input',
                attr: { type: 'checkbox' },
                width: 'Z',
                height: 'Z'
              },
              CheckLabel: {
                text: '{{ unison | polyglot }}',
                fontSize: 'Z',
                color: 'inkText'
              }
            }
          },
          SaveBtn: {
            extends: 'Button',
            text: '{{ saveSettings | polyglot }}',
            marginTop: 'A',
            background: '#0D1117',
            color: '#FFFFFF',
            fontWeight: '600',
            padding: 'Z B',
            round: 'B',
            fontSize: 'Z',
            cursor: 'pointer',
            border: 'none'
          }
        }
      },

      // ─── AI REDIRECT ──────────────────────────────
      AiDashView: {
        flow: 'y',
        gap: 'A',
        show: (el, s) => s.root.activeTab === 'ai',
        padding: 'D',
        align: 'center center',
        AiRedirectMsg: {
          flow: 'y',
          gap: 'A',
          align: 'center center',
          textAlign: 'center',
          AiIcon: {
            extends: 'Icon',
            icon: 'sparkle',
            width: 'C',
            height: 'C',
            color: 'purple'
          },
          AiText: {
            text: '{{ aiToolsAreAvailable | polyglot }}',
            fontSize: 'A',
            color: 'inkMuted'
          },
          AiLink: {
            extends: 'Link',
            text: '{{ openTheFullAi | polyglot }}',
            href: '/ai',
            fontSize: 'A',
            fontWeight: '600',
            color: 'purple',
            textDecoration: 'none',
            cursor: 'pointer'
          }
        }
      }
    }
  }
}
